<template>
    <div>
        <div v-for="(item , index) in regularData" :key="index">
            <div class="rule_li" v-if="item.countData.length != 0">
                <div class="title">{{item.title}}</div>
                <div :class="items == item.default?'rule_li_btn_s':'rule_li_btn'" @click="item.default = items" v-for="(items, indexs) of item.countData" :key="indexs">
                    {{items}}
                </div>
            </div>
        </div>

        <div>
            <div class="rule_li" >
                <div class="title">比赛模式</div>
                <div class="rule_li_content">
                    <div v-for="(item , index) in MethodData" :key="index">
                        <div :class="MethodDataMode == item.mode?'rule_li_btn_s':'rule_li_btn'" @click="MethodDataModeClick(item)" >
                            {{item.name}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-for="(item , index) in extension" :key="index">
            <div class="rule_li" v-show="groupConfig(item) && userCountFun(item) && modeFun(item)">
                <div class="title">{{item.title}}</div>
                <div class="rule_li_content">
                    <div v-for="(items, indexs) of item.names" :key="items">
                        <div @click="extensionClick(item , items , indexs)" :class="extensionClass(item , items , indexs)?'rule_li_btn_s':'rule_li_btn'">{{items}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="btnStyle">
            <el-button size="small" @click="GameRulesCancel">取消</el-button>
            <el-button size="small" type="primary"  @click="GameRulesSubmit('editForm')">保存</el-button>
        </div>
    </div>
</template>
<script>

import axios from 'axios';
import { ruleDetail ,mjdGamerule , matchwayDetail } from '../../api/competition';
import { CompetitionMethodData, CompetitionMethodNum } from '../../utils/CompetitionMethod'
export default {
    props:{
        stageId:{
            type:String,
            value:'',
        },
        gameId:{
            type:String,
            value:'',
        },
        matchId:{
            type:String,
            value:'',
        },
        matchGame:{

        }
    },
    data(){
        return{
            regularData:{},
            extension:[],
            componentKey:0,
            refresh:true,
            ruleData:null,
            editRuleData:{},
            MethodData:[],
            MethodDataMode:0,
            MethodDataUnit:1,
        }
    },
    components: {

    },
    created(){
        console.log(this.stageId)
        console.log(this.matchGame)
        this.matchwayDetailFun()
        ruleDetail(this.stageId).then(res=>{
            if(res.data != null){
                this.editRuleData = res.data
                this.ruleData = JSON.parse(res.data.ruleJson)
            }   
            console.log(this.ruleData)
            this.getRuleData()
        })
    },
    methods:{
        matchwayDetailFun(){
            matchwayDetail(this.stageId).then(res=>{
                if(res.data == null){
                    let MethodData = []
                    CompetitionMethodData().forEach(item=>{
                        console.log(item)
                        if((this.matchGame.unit&item.unit) != 0){
                            MethodData.push(item)
                        }
                    })
                    console.log(MethodData)
                    this.MethodData = MethodData
                    this.MethodDataMode = MethodData[0].mode
                    this.MethodDataUnit = MethodData[0].unit
                }else {
                    let MethodData = []
                    CompetitionMethodData().forEach(item=>{
                        console.log(item)
                        if((this.matchGame.unit&item.unit) != 0){
                            MethodData.push(item)
                        }
                    })
                    console.log(MethodData)
                    this.MethodData = MethodData
                    this.MethodDataMode = MethodData.find(item => item.unit === res.data.gameUnit).mode
                    this.MethodDataUnit = res.data.gameUnit
                }
            })
        },
        
        MethodDataModeClick(item){
            this.MethodDataMode = item.mode
            this.MethodDataUnit = item.unit
        },
        GameRulesCancel(){
            this.$emit('cancel')
        },
        getRuleData(){
            mjdGamerule(this.gameId).then(res=>{
                if(res.data == undefined){
                    this.$message.error(res.errMsg)
                }else {
                    axios({
                        method: 'get',
                        url: res.data,
                    }).then(res=>{
                        console.log(res.data)
                        let data = res.data.lobby_setting
                        if(this.ruleData == null){
                            this.regularData = {
                                user_count_title:{
                                    title:data.user_count_title,
                                    default:data.user_count_default,
                                    countData:data.user_count,
                                },
                                // ju_count_title:{
                                //     title:data.ju_count_title,
                                //     countData:data.ju_count,
                                //     default:''
                                // },
                            }
                            this.extension = data.extension
                        }else {
                            this.regularData = {
                                user_count_title:{
                                    title:data.user_count_title,
                                    default:this.ruleData.bSets[1],
                                    countData:data.user_count,
                                },
                                // ju_count_title:{
                                //     title:data.ju_count_title,
                                //     countData:data.ju_count,
                                //     default:this.obj.bSets[2]
                                // },
                            }
                            for(let item of data.extension){
                                item.defaults = this.extensionEcho(item)
                            }
                            this.extension = data.extension
                        }
                    })
                }
            })
        },
        extensionEcho(row){
            console.log(row)
            let defaults = []
            let num  = this.ruleData.iSets[row.group]
            console.log(num)
            row.names.forEach((item, index, arr) => {
                console.log(index+":"+item)
                if((num&1<<index) != 0){
                    defaults.push(index)
                }
            })
            return defaults
        },
        GameRulesSubmit(){
            // console.log(this.extension)
            let bSets = [0,0,0,0,0,0,0,0,0,0,]
           
            const maxValue = Math.max(...this.extension.map(obj => obj.group))
            let iSets = new Array(maxValue + 1).fill(0)
            console.log(iSets)
            for(let item of this.extension){
                if(item.type == "mutex"){
                    iSets[item.group] = 1<<item.defaults[0]
                }else {
                    let defaultNum = 0
                    for(let items of item.defaults){
                        defaultNum = defaultNum|1<<items
                    }
                    iSets[item.group] = defaultNum
                }
                // console.log(item)
            }
            for(let item in this.regularData){
                // console.log(item)
                if(this.regularData[item].countData.length != 0){
                    if(item == 'user_count_title'){
                        bSets[1] = this.regularData[item].default
                    }
                    // else if (item == 'ju_count_title'){
                    //     bSets[2] = this.regularData[item].default
                    // }
                }
            }

            let parData = this.editRuleData
            parData.matchId = this.matchId
            parData.stageId = this.stageId
            parData.gameId = this.gameId
            parData.gameUnit = this.MethodDataUnit
            parData.pnum = bSets[1]
            parData.ruleJson = JSON.stringify({
                iSets:iSets,
                bSets:bSets,
                "gameID": this.gameId,
            })
            this.$emit('submitFun' , parData)
        },
        // 根据user判断显示
        userCountFun(item){
            if(item.user_count == undefined){
                return true
            }else{
                if(item.user_count == this.regularData.user_count_title.default){
                    return true
                }else {
                    return false
                }
            }
            console.log(item)
        },
        // 根据mode判断
        modeFun(item){
            if(item.limit_mode == undefined){
                return true
            }else{
                if(item.limit_mode == this.MethodDataMode){
                    return true
                }else {
                    return false
                }
            }
        },
        // 显示隐藏逻辑处理
        groupConfig(item){
            if(!item.extra)return true
            if(!item.extra.includes('limit'))true
            let limitList = item.extra.split('|')
            let _list = []
            if(limitList[1] == 'group'){
                if(limitList.length%2 != 0){
                    return true
                }
                for(let i = 2;i < limitList.length; i++){
                    i++
                    _list.push({
                        group:Number(limitList[i-1]),
                        index:Number(limitList[i])
                    })
                }
                let _state = false
                if(limitList[0] == 'limitOrHide'){
                    _state = !this.groupFlagOr(_list)
                }else if(limitList[0] == 'limitAndHide'){

                }else if(limitList[0] == 'limitOrShow'){
                    _state = this.groupFlagOr(_list)
                }else if(limitList[0] == 'limitAndShow'){
                    
                }
                // console.log(_list)
                return _state
            }
        },
        groupFlagOr(_list){
            for(let item of this.extension){
                for(let items of _list){
                    // console.log(item.group == items.group && item.defaults.indexOf(items.index) == 0)
                    if(item.group == items.group && item.defaults.indexOf(items.index) == 0){
                        return true
                    }
                }
            }
            return false
        },
        // 选中状态逻辑处理
        extensionClass(data , items , indexs){
            let flag = false
            for(let item of data.defaults){
                // console.log(item)
                if(item == indexs){
                    flag = true
                }
            }
            return flag
        },
        // 动态规则点击事件
        extensionClick(item , items , indexs){
            console.log()
            if(item.type =='mutex'){
                console.log(item.defaults)
                item.defaults = [] 
                item.defaults = [indexs]
            }else{
                if(item.defaults.indexOf(indexs) == -1){
                    item.defaults.push(indexs)
                }else {
                    item.defaults = item.defaults.filter((value)=>{
                        return value != indexs
                    })
                }
            }
            // this.refresh = false
            // // 在组件移除后，重新渲染组件
            // // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
            // this.$nextTick(() => {
            //     this.refresh = true
            // })
        }
        
    }
}
</script>
<style scoped>
  .rule_li{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
    flex-wrap: wrap;
    padding:20px
  }
  .title{
    font-size: 18px;
    font-weight: bold;
    width: 160px;
    text-align: center;
  }
  .rule_li_content{
    display: flex;
    align-content: center;
    flex: 1;
    flex-wrap: wrap;
  }
  .rule_li_btn{
    /* width: 100px; */
    height: 40px;
    line-height: 40px;
    border: 1px solid #ccc;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    cursor: pointer;
    padding: 0 30px;
    margin: 10px 0 ;
  }
  .rule_li_btn_s{
    height: 40px;
    line-height: 40px;
    border: 1px solid #8bf388;
    text-align: center;
    color: #8bf388;
    font-weight: bold;
    font-size: 18px;
    cursor: pointer;
    padding: 0 30px;
    margin: 10px 0 ;
  }
  .btnStyle{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 50px;
  }
</style>


// WEBPACK FOOTER //
// src/components/competition/GameRules.vue